// src/components/PrivateRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import Spinner from "./Spinner";
import { useAuth } from "../context/AuthContext";

export default function PrivateRoute({ children, allowedRoles = [] }) {
  const { user, loading, userRole } = useAuth();
  const location = useLocation();

  // Mientras carga auth / perfil
  if (loading) {
    return <Spinner />;
  }

  // Si no está logueado, redirige a login
  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Si hay restricción de roles y el rol no está en la lista, redirige a /
  if (
    allowedRoles.length > 0 &&
    // userRole debe coincidir con alguno de los permitidos
    !allowedRoles.includes(userRole)
  ) {
    return <Navigate to="/" replace />;
  }

  // Acceso concedido
  return children;
}
